<template>
  <div class="mx-3">
    <b-row>
      <b-col sm="3">
        <b-card border-variant="light" header="Light" header-bg-variant="white" class="shadow-1" id="tooltip-target-2">
          <div slot="header">
            <div style="float: left;" class="m-2">Sin Movimiento</div>
            <div style="float: right; margin-top: 8px;">
              <b-button class="text-white" size="sm" variant="info" @click="goToGeneralKeyKpiAnalysisView('productWm')">Reporte
              </b-button>
            </div>
          </div>
          <div style="height: 30px;" class="text-center">
            <h3>{{$_formatMetricValueVerbose('UNITS' ,wmProductCount)}}</h3>
          </div>
          <b-tooltip target="tooltip-target-2" triggers="hover">
            {{_reportParameters.productWm.dashBoardIndicatorTooltip}}
          </b-tooltip>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card border-variant="light" header="Light" header-bg-variant="white" class="shadow-1" id="tooltip-target-3">
          <div slot="header">
            <div style="float: left;" class="m-2">Quebrados</div>
            <div style="float: right; margin-top: 8px;">
              <b-button class="text-white" size="sm" variant="info" @click="$router.push({'name': 'stockBreak'})">Reporte
              </b-button>
            </div>
          </div>
          <div class="text-center" style="height: 30px;">
            <h3>{{$_formatMetricValueVerbose('UNITS' ,stockBreakCount)}}</h3>
          </div>
          <b-tooltip target="tooltip-target-3" triggers="hover">
            {{_reportParameters.stockBreak.dashBoardIndicatorTooltip}}
          </b-tooltip>
        </b-card>
      </b-col>
      <b-col sm="6">
<!--        <b-card-->
<!--          border-variant="light"-->
<!--          header="Light"-->
<!--          header-bg-variant="white"-->
<!--          class="shadow-1"-->
<!--          body-class="py-1"-->
<!--        >-->
<!--          <div slot="header">-->
<!--            <div style="float: left;" class="m-2">Últimas Publicaciones</div>-->
<!--            <div style="float: right; margin-top: 8px;">-->
<!--              <b-button class="text-white" size="sm" variant="info" @click="goToView('StorePublicationContent')">-->
<!--                Reporte-->
<!--              </b-button>-->
<!--            </div>-->
<!--          </div>-->
<!--         <b-row>-->
<!--            <b-col-->
<!--              v-for="newsFeedIndicator in newsFeedIndicators"-->
<!--              :key="newsFeedIndicator.description"-->
<!--              class="text-wrap text-center"-->
<!--            >-->
<!--              <p -->
<!--                v-b-tooltip.hover -->
<!--                :title="newsFeedIndicator.description"-->
<!--                class="mb-1"-->
<!--              >-->
<!--                {{ getIndicatorShortname(newsFeedIndicator) }}-->
<!--              </p>-->
<!--              <h3> {{ newsFeedIndicator.count }} </h3>-->
<!--            </b-col>-->
<!--          </b-row>-->
<!--        </b-card>-->
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import {sales, trade} from '../../../services/api/ExpertoRetail'
  import { productsWm, stockBreakTotal } from '@/expertoRetail/atoms/StockIndicators/baseParameters'
  import { reportParameters } from '../../library/requestParameters/generalKeyApiAnalysisRequestParameters'

  export default {
    name: 'TheKpiCardStrip',
    mixins: [GeneralUtils, DimensionUtils],
    props: {
      wmProductCount: {
        type: Number,
        required: true
      },
      stockBreakCount: {
        type: Number,
        required: true
      },
      newsFeedIndicators: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        _reportParameters: {},
        selectOptions: null,
        selected: '',
        loading: false
      }
    },
    created () {
      this.selected = this.$_dimensionUtils_getDimFromDimension(this.vuexSelectedDim.card1)
      this.selectOptions = this.renameDataForSelectOptions()
      this.$store.commit('commit_initCleanStates')
      this._reportParameters = reportParameters
    },
    watch: {
      'selected' (value) {
        this.getSelectedDimension(value, 'card1')
      }
    },
    computed: {
      vuexSelectedDim () {
        return this.$store.state.accumulatedSales.selectedDimension
      },
      vuexGlobalFilters () {
        return this.$store.state.app.globalFilters
      }
    },
    methods: {
      renameDataForSelectOptions () {
        let newObj = this.$_generalUtils_deepJsonCopy(this.$store.getters.dataPivotDimensions).map(({description: text, dim_value: value}) =>
          ({text, value}))
        return newObj
      },
      getSelectedDimension (selection, card) {
        let dim = this.$_dimensionUtils_getDimensionParameter(selection)
        this.$store.commit('commit_selectedDimension', [dim, card])
        this.$store.commit('commit_gridMainDim', dim)
        return dim
      },
      goToView (view) {
        this.$router.push({'name': view})
      },
      goToGeneralKeyKpiAnalysisView (reportName) {
        this.$store.commit('commit_genKeyKpiAnalysis_selectedReport', reportName)
        this.$router.push({'name': 'GeneralKeyKpiAnalysis'})
      },
      getIndicatorShortname (indicator) {
        return indicator.description.split(' ').map(x => x[0]).join('').slice(0,2)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/Dashboard/KpiCardStrip.vue